import React from "react";
import PropTypes from "prop-types";

const Panel = ({ children, id, selectedKey }) => {
	const isSelected = id === selectedKey;
	return (
		<section
			aria-hidden={!isSelected}
			style={{ display: isSelected ? "block" : "none" }}
			id={id}
			role="tabpanel"
			tabIndex={isSelected ? 0 : -1}>
			{children}
		</section>
	);
};

Panel.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	id: PropTypes.string.isRequired,
	selectedKey: PropTypes.string,
};

Panel.defaultProps = {
	selectedKey: undefined,
};

export default Panel;
export { Panel };
